<div class="panel" [class.valor-financiado__disabled-event]="disabled">
    <h3>Valor Financiado</h3>
    <ng-container *ngIf="!simulacao; else textoSimulacaoTemplateRef">
      <p class="max" *ngIf="!simulacao">Máximo {{cotacao || 0 | currency:'BRL':'symbol':'1.2-2'}}</p>
      <span class="valor-financiado__warning">Modifique o Valor e obtenha uma nova simulação</span>
    </ng-container>
    <ng-template #textoSimulacaoTemplateRef>
      <p class="max">Valor Máximo a ser Financiado {{cotacao || 0 | currency:'BRL':'symbol':'1.2-2'}}</p>
    </ng-template>

    <div class="valor-financiado__group">
      <span class="input-group-btn data-dwn">
        <a class="btn btn-number" data-dir="dwn">
          <i class="fa fa-minus" (click)="onClickMinus()"></i>
        </a>
      </span>
        <label class="valor-financiado__valor-simular">{{valorSimular || 0 | currency:'BRL':'symbol':'1.2-2'}}</label>
        <span class="input-group-btn data-up ">
        <a class="btn btn-number" data-dir="up">
          <i class="fa fa-plus" (click)="onClickPlus()" ></i>
        </a>
      </span>
    </div>

    <div class="valor-financiado__slider">
      <app-slider-valor-financiado
        [disabled]="disabled"
        [valorMin]="valorMinimo"
        [valorMax]="cotacao"
        [(valor)]="valorSimular"
        (valorChange)="onChangeValorSimular()">
      </app-slider-valor-financiado>
    </div>

    <p *ngIf="simulacao" class="valor-financiado__warning">Modifique o valor e obtenha uma nova simulação</p>

    <p class="border"></p>

    <a (click)="openModalAlterarValor()" class="valor-financiado__action">alterar valor</a>
    <app-simulation-message></app-simulation-message>
    <span *ngIf="simulacao" class="valor-financiado__info">Caso queira fazer uma nova simulação, basta modificar o valor acima utilizando os botões, a régua ou alterando o valor.</span>

</div>
